import { createSelector } from 'reselect'
import confirmTypes from 'helpers/enums/confirmTypes'
import { localize } from 'helpers/translator'
import studentSlideTimerSelector from 'redux/selectors/student/timer'
import { sessionTypesWithNoSubmit, sessionTypesWithSubmitDisabled } from 'helpers/session/submitOptions'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.RICH_TEXT_STUDENT_SESSION,
])

const getStudentViewData = state => state.student
const getConfirmsData = state => state.confirm
const getSlideId = (state, props) => props.session.session_uid + '_' + props.slide.slideId

function buildIntroSubText(questionsLength, slideSubtype) {
	if (slideSubtype === 'trueFalse') {
		return ''
	} else {
		if (questionsLength > 1) {
			return `${questionsLength} ${localize('quiz_intro_questions')}`
		} else {
			return `${questionsLength} ${localize('quiz_intro_question')}`
		}
	}
}

const buildConfirmTexts = (confirmType, questions) => {
	const questionsCount = questions.length
	const hasUnansweredQuestions = !!questions.find(question => question.selected_answers.length === 0)
	let confirmTexts
	if (hasUnansweredQuestions) {
		if (confirmType === confirmTypes.STUDENT_SUBMIT_QUIZ_EMPTY_ANSWERS_REQUIRED) {
			confirmTexts = {
				mainText: questionsCount === 1
					? localize('qa_submit_required_text')
					: localize('quiz_submit_required_text'),
				actionTwoText: localize('action_button_gotit_cancel'),
			}
		} else {

			confirmTexts = {
				mainText: questionsCount === 1
					? localize('qa_submit_confirm_empty_question_text')
					: localize('quiz_submit_confirm_empty_question_text'),
				actionOneText: questionsCount === 1
					? localize('qa_submit_confirm_empty_actionone_text')
					: localize('quiz_submit_confirm_empty_actionone_text'),
				actionTwoText: localize('quiz_submit_confirm_empty_actiontwo_text'),
			}
		}
	}
	return confirmTexts
}

const getStudentSlideData = createSelector(
	[
		getStudentViewData,
		getConfirmsData,
		studentSlideTimerSelector,
		getSlideId,
		featureFlagsSelector,
	],
	(student, confirms, timer, slideId, featureFlags) => {

		const slide_data = student.slides[slideId]
		let isImmersiveReaderEnabled = false

		let no_answers_message, footer_message = '', current_question, showQuestionNumber, isTrueFalse, introText, introSubtext
		if (slide_data) {
			current_question = slide_data.questions[slide_data.currentQuestionIndex]
			no_answers_message = current_question.canMultiSelect ?
				localize('student_slide_selector_multianswer_text') :
				localize('student_slide_selector_oneanswer_text')
			if (current_question.selected_answers) {
				footer_message = current_question.selected_answers.length > 0 ?
					`${current_question.selected_answers.length} ${localize('student_slide_selector_selected_text')}` :
					no_answers_message
			}
			showQuestionNumber = !slide_data.subtype
			introText = slide_data.subtype === 'trueFalse' ? localize('true_false_intro_title') : localize('quiz_intro_title')
			isTrueFalse = slide_data.subtype === 'trueFalse'
			introSubtext = buildIntroSubText(slide_data.questions.length, slide_data.subtype)
			isImmersiveReaderEnabled = slide_data.shouldShowImmersiveReader
		}


		let confirm
		if (confirms.length) {
			const confirmsArray = [
				confirmTypes.STUDENT_SUBMIT_QUIZ_EMPTY_ANSWERS_CONFIRM,
				confirmTypes.STUDENT_SUBMIT_QUIZ_EMPTY_ANSWERS_REQUIRED,
				confirmTypes.STUDENT_SUBMIT_QUIZ_CONFIRMED,
				confirmTypes.STUDENT_SUBMIT_FAILED_CONFIRM,
			]
			const confirmType = confirms.length && confirmsArray.includes(confirms[0].confirmType) ?
				confirms[0].confirmType :
				null

			if (confirmType) {
				const confirmTexts = buildConfirmTexts(confirmType, slide_data.questions)
				confirm = { type: confirmType, ...confirmTexts }
			}
		}

		return {
			slide_data,
			confirm,
			footer_message,
			timer,
			showQuestionNumber,
			isTrueFalse,
			introText,
			introSubtext,
			isSubmitHidden: sessionTypesWithNoSubmit.includes(student.sessionType),
			isSubmitDisabled: sessionTypesWithSubmitDisabled.includes(student.sessionType),
			shouldShowImmersiveReader: isImmersiveReaderEnabled,
			shouldShowHTMLComponent: featureFlags[featureFlagsTypes.RICH_TEXT_STUDENT_SESSION],
		}
	}
)

export default getStudentSlideData
